
import { FC, useCallback } from 'react'
import { useAuth } from '../../../../app/modules/auth'
import { toAbsoluteUrl } from '../../../helpers'
import { Logout } from '../../../../app/modules/core/_request'
import { useSnackbar } from '../../../context/SnackbarContext'
import { AppDispatch } from '../../../../redux/store'
import { useDispatch } from 'react-redux'
import { clearReduxAction } from '../../../../redux/actions/auth.actions'
import { useQueryClient } from "@tanstack/react-query";
import { getApiErrorMessage } from "../../../../utils/utils";

const HeaderUserMenu: FC = () => {
  const queryClient = useQueryClient();
  const { showSnackbar } = useSnackbar()
  const { auth, logout } = useAuth()
  const dispatch = useDispatch<AppDispatch>()

  const handleLogout = useCallback(async () => {
    try {
      if (!auth?.user_id) return;
      const response = await Logout(auth?.user_id);

      if (response.status === "ok") {
        showSnackbar(response.message, "success");
        logout({ skipReturnUrl: true });
        dispatch(clearReduxAction())
        queryClient.clear();
      } else {
        showSnackbar(response.message, "danger");
      }
    } catch (error) {
      console.error("Logout failed:", error);
      showSnackbar(getApiErrorMessage(error, "Something went wrong during logout"), "danger");
    }
  }, [auth, logout, showSnackbar]);



  return (
    <div
      className='menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-600 menu-state-bg menu-state-primary fw-semibold py-3 mt-1 fs-6 w-fit-content'
      data-kt-menu='true'
    >
      <div className='menu-item px-3'>
        <div className='menu-content d-flex align-items-center px-3'>
          <div className='symbol symbol-50px me-5'>
            <img alt='Logo' src={toAbsoluteUrl('media/avatars/blank.png')} />
          </div>

          <div className='d-flex flex-column'>
            <div className='fw-bold d-flex align-items-center fs-5'>
              {auth?.first_name} {auth?.last_name}
              {/* <span className='badge badge-light-success fw-bold fs-8 px-2 py-1 ms-2'>Pro</span> */}
            </div>
            <a href='#' className='fw-semibold text-muted text-hover-primary fs-7'>
              {auth?.email}
            </a>
          </div>
        </div>
      </div>
      <div className='separator my-2'></div>
      <div className='menu-item px-5'>
        <a onClick={handleLogout} className='menu-link px-5'>
          Sign Out
        </a>
      </div>
    </div>
  )
}

export { HeaderUserMenu }
